import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const TeensFirstPeriodOrganicGuide = () => {
  useMetaTags({
    title: "Teen's First Period Guide | Why Choose Organic Pads?",
    description: "A guide for teenagers on their first period. Learn why organic pads are the best choice for comfort, safety, and health-conscious menstrual care.",
    keywords: "first period guide, teen menstrual health, organic pads for teens, best pads for first period, eco-friendly period care, teen period tips",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/teens-first-period-organic-guide",
    ogTitle: "Teen's First Period Guide | Why Choose Organic Pads?",
    ogDescription: "Starting your period journey with organic pads is a great choice for comfort and health. Learn why organic pads are best for teens!",
    ogImage: "https://images.unsplash.com/photo-1576678927484-cc907957088c?w=600",
    ogUrl: "https://organicpads.shop/teens-first-period-organic-guide",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Teen's First Period Guide | Why Choose Organic Pads?",
    twitterDescription: "A complete guide for teenagers on their first period. Discover why organic pads offer the best protection and comfort for young skin.",
    twitterImage: "https://images.unsplash.com/photo-1576678927484-cc907957088c?w=600",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/teens-first-period-organic-guide"
    },
    "headline": "Teen's First Period Guide | Why Choose Organic Pads?",
    "description": "A guide for teenagers on their first period. Learn why organic pads are the best choice for comfort, safety, and health-conscious menstrual care.",
    "image": "https://images.unsplash.com/photo-1576678927484-cc907957088c?w=600",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "first period guide",
      "teen menstrual health",
      "organic pads for teens",
      "best pads for first period",
      "eco-friendly period care",
      "teen period tips"
    ]
  }
  

  return (
    <>
    <div className="max-w-3xl mx-auto p-6 text-gray-800">
      <h1 className="text-3xl font-bold text-center text-green-600">
        A Teenager's Guide to First Period: Why Start With Organic
      </h1>
      <img
        src="https://images.unsplash.com/photo-1576678927484-cc907957088c?w=600"
        alt="Teen Period Guide"
        className="w-full mt-4 rounded-lg"
      />
      <p className="mt-4 text-lg">
        Starting your period journey with organic products can set a foundation
        for lifelong menstrual health. This guide helps teenagers understand
        why choosing organic from the start matters and how to navigate their
        first period confidently.
      </p>
      
      <h2 className="text-2xl font-semibold mt-6">Benefits for Young Bodies</h2>
      <ul className="list-disc pl-6 mt-2 space-y-1">
        <li>Gentle introduction to periods</li>
        <li>Reduced chemical exposure</li>
        <li>Better skin sensitivity care</li>
        <li>Natural comfort experience</li>
        <li>Health-conscious habits</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6">How to Start Your Period Journey?</h2>
      <p className="mt-2">
        Look for <strong>teen-friendly</strong> organic pads that offer proper
        protection while being gentle on young, sensitive skin.
      </p>
      
      <img
        src="https://plus.unsplash.com/premium-photo-1702598576513-fe7425ebf6bd?w=600"
        alt="Teen Care"
        className="w-full mt-4 rounded-lg"
      />
      
      <h2 className="text-2xl font-semibold mt-6">Final Thoughts</h2>
      <p className="mt-2 font-semibold text-green-600">
        Start your period journey the right way. <strong>Choose organic from day one!</strong>
      </p>
    </div>
    {/* Schema Markup */}
    <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default TeensFirstPeriodOrganicGuide;
